<template>
    <a class="item-button"
       :class="{'item-button--disabled': !enabled}"
       @click.prevent="click">
        <span class="item-button__name">{{ name }}</span>

        <span v-if="item.hasWaiver"
              class="item-button__waiver-icon"><i class="fa-solid fa-file-signature"></i></span>

        <!-- Note there is no seat icon here because open tickets cannot have a seating chart -->
    </a>
</template>

<script>
import ItemType from '@/lib/Items/ItemType';
import { container } from '@/container';
import { mapState } from 'vuex';

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },

    emits: [
        'click',
    ],

    computed: {
        ...mapState(['isOnline']),

        name() {
            return this.item.getName();
        },

        enabled() {
            if (!this.isOnline && this.item.hasWaiver) {
                // Disable the button if not online and the item has a waiver.
                return false;
            }

            return true;
        },
    },

    methods: {
        click() {
            const { hasWaiver, itemType, event } = this.item || {};
            if (!this.isOnline && hasWaiver) {
                container.toastFactory.infoTop('SELL.WAIVER_UNAVAILABLE_OFFLINE');
                return;
            }

            // Check for event based tickets without event.
            if (itemType === ItemType.TICKET && this.item.isSessionBased() && !event) {
                container.toastFactory.infoTop('SELL.NO_ACTIVE_EVENT_FOUND_FOR_THE_TICKET');
                return;
            }

            this.$emit('click');
        },
    },
};
</script>

<!-- .item-button styles are in the ItemPanel component because they are used by both EventButton and ItemButton -->
